<template>
  <withTopNav :leftText="$t('Activities.Agentrule.Title')" fixed>
    <div
      class="pt-8 agentCenterBox h-[calc(100vh-var(--vh-offset,0px))] overflow-scroll text-[#fff] rule-content"
    >
      <div class="px-4">
        <img :src="wuxianji_01" alt="" class="w-full" />
      </div>
      <img :src="wuxianji_02" alt="" class="w-full" />
      <div class="px-4 mt-8">
        <div class="text-[13px] leading-6">
          <div class="text-[#FFDF12] !text-[15px]">
            {{ $t('Activities.Agentrule.CurrentCommissionSettings') }}
          </div>
          <br />
          {{ $t('Activities.Agentrule.Level1Agent', { depositRatios: agent1?.depositRatios, betRatios: agent1?.betRatios }) }}
          <br />
          <br />
          {{ $t('Activities.Agentrule.Level2Agent', { depositRatios: agent2?.depositRatios, betRatios: agent2?.betRatios }) }}
          <br />
          <br />
          {{ $t('Activities.Agentrule.Level3Agent', { depositRatios: agent3?.depositRatios, betRatios: agent3?.betRatios }) }}
          <br />
          <br />
          {{ $t('Activities.Agentrule.BusinessOpportunity') }}
          <br />
          <br />
          {{ $t('Activities.Agentrule.SecondDayRecruitment') }}
        </div>
        <div>
          <DataTable :columns="columns" :data="data" />
        </div>
        <div class="mt-10 rounded-xl">
          <div
            class="bg-[#2C7952]/70 rounded-lg mb-1 text-2xl text-center px-2 py-3 text-[#fff]"
          >
            {{ $t('Activities.Agentrule.CommissionCalculationRules') }}
          </div>
          <div class="rounded-xl">
            <div class="px-4 py-2 bg-[#2C7952]/40 flex items-center justify-between">
              <img :src="wuxianji_05" alt="" class="w-[62px]" />
              <div class="flex flex-col items-end font-[500] text-base">
                <span class="text-[10px]">{{ $t('Activities.Agentrule.TotalCommission') }}</span>
                <span class="text-[18px] mt-1">{{
                  formatter().format(num1 + num2 + num3)
                }}</span>
              </div>
            </div>
            <div
              class="flex px-4 py-2 mt-1 rounded-lg items-center justify-between bg-[#2C7952]/20"
            >
              <img :src="wuxianji_09" alt="" class="w-[70px]" />
              <div class="flex flex-col items-end text-sm flex-1">
                <span class="text-[10px]">{{ $t('Activities.Agentrule.DirectAgentCommission') }}</span>
                <span class="text-[18px]">{{ formatter().format(num1) }}</span>
              </div>
            </div>
            <div
              class="flex px-4 py-2 mt-1 rounded-lg items-center justify-between bg-[#2C7952]/40"
            >
              <img :src="wuxianji_12" alt="" class="w-[70px]" />
              <div class="flex flex-col items-end flex-1">
                <span class="text-[10px]">{{ $t('Activities.Agentrule.Level2AgentCommission') }}</span>
                <span class="text-[18px]">{{ formatter().format(num2) }}</span>
              </div>
            </div>
            <div
              class="flex px-4 py-2 mt-1 rounded-lg items-center justify-between bg-[#2C7952]/40"
            >
              <img :src="wuxianji_14" alt="" class="w-[24px]" />
              <div class="flex flex-col items-end flex-1">
                <span class="text-[10px]">{{ $t('Activities.Agentrule.Level3AgentCommission') }}</span>
                <span class="text-[18px]">{{ formatter().format(num3) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between gap-2 mt-6 text-xs font-[500]">
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px]" />
            <span class="mt-2 mb-4 text-[12px]">
              B1 Para A:
              <i class="not-italic text-[#FF0000]">{{
                formatter().format(
                  caculateNum(500, 1000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}</i>
            </span>
            <img :src="wuxianji_31" class="w-[100px]" alt="" />
          </div>
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px]" />
            <span class="mt-2 mb-4 text-[12px]">
              B1 Para A:
              <i class="not-italic text-[#FF0000]">{{
                formatter().format(
                  caculateNum(2000, 1500, agent1?.depositRatios, agent1?.betRatios)
                )
              }}</i>
            </span>
            <img :src="wuxianji_34" alt="" class="w-[100px]" />
          </div>
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px]" />
            <span class="mt-2 mb-4 text-[12px]">
              B1 Para A:
              <i class="not-italic text-[#FF0000]">{{
                formatter().format(
                  caculateNum(1500, 2000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}</i>
            </span>
            <img :src="wuxianji_28" alt="" class="w-[100px]" />
          </div>
        </div>
        <div class="flex items-center justify-between gap-2 mt-6 text-xs font-[500]">
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px]" />
            <div class="mt-2 mb-4 flex flex-col items-center justify-center">
              <span class="text-[12px] mb-2">
                C1 Para A:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(3000, 8000, agent2?.depositRatios, agent2?.betRatios)
                  )
                }}</i>
              </span>
              <span class="text-[12px]">
                C1 Para B1:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(3000, 8000, agent1?.depositRatios, agent1?.betRatios)
                  )
                }}</i>
              </span>
            </div>
            <img :src="wuxianji_43" alt="" class="w-[100px]" />
          </div>
          <div class="flex flex-col items-center justify-center flex-1">
            <div class="h-[62px] w-full flex items-start">
              <img :src="wuxianji_40" alt="" class="w-[60px]" />
            </div>
            <div class="mt-2 mb-4 flex flex-col items-center justify-center">
              <span class="text-[12px] mb-2">
                C2 Para A:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(1000, 2000, agent2?.depositRatios, agent2?.betRatios)
                  )
                }}</i>
              </span>
              <span class="text-[12px]">
                C2 Para B1:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(1000, 2000, agent1?.depositRatios, agent1?.betRatios)
                  )
                }}</i>
              </span>
            </div>
            <img :src="wuxianji_45" alt="" class="w-[100px]" />
          </div>
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px]" />
            <div class="mt-2 mb-4 flex flex-col items-center justify-center">
              <span class="text-[12px] mb-2">
                C3 Para A:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(8000, 5000, agent2?.depositRatios, agent2?.betRatios)
                  )
                }}</i>
              </span>
              <span class="text-[12px]">
                C3 Para B3:
                <i class="not-italic text-[#FF0000]">{{
                  formatter().format(
                    caculateNum(8000, 5000, agent1?.depositRatios, agent1?.betRatios)
                  )
                }}</i>
              </span>
            </div>
            <img :src="wuxianji_47" alt="" class="w-[100px]" />
          </div>
        </div>
        <div class="flex items-end justify-start gap-2 mt-6 text-xs font-[500]">
          <div class="flex flex-col items-center justify-center flex-1">
            <img :src="wuxianji_18" alt="" class="w-[34px] mb-6" />
            <img :src="wuxianji_51" alt="" class="w-[100px]" />
          </div>
          <div
            class="flex-2 w-2/3 flex flex-col items-start justify-end pl-[33px] pb-[13px]"
          >
            <span class="text-[12px] mb-2">
              D1 Para A:
              <i class="not-italic text-[#FF0000]">{{ formatter().format(num3) }}</i>
            </span>
            <span class="text-[12px]">
              D1 Para B1:
              <i class="not-italic text-[#FF0000]">{{
                formatter().format(
                  caculateNum(6000, 3000, agent2?.depositRatios, agent2?.betRatios)
                )
              }}</i>
            </span>
            <span class="mb-7 mt-2 text-[12px]">
              D1 Para C1:
              <i class="not-italic text-[#FF0000]">{{
                formatter().format(
                  caculateNum(6000, 3000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}</i>
            </span>
          </div>
        </div>
        <div class="mt-10 mb-7">
          <h3 class="text-[15px] text-[#FFDF12] mb-4">
            {{ $t('Activities.Agentrule.CommissionCalculationMethod') }}
          </h3>
          <ul class="text-[12px]">
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.C1Commission') }}</li>
            <li class="ml-4">
              6000 * {{ agent1?.depositRatios }}% + 3000 * {{ agent1?.betRatios }}% =
              {{
                formatter().format(
                  caculateNum(6000, 3000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}
            </li>
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.B1Commission') }}</li>
            <li class="li-circle ml-6">
              {{ $t('Activities.Agentrule.CommissionCalculation.B1DirectCommission') }} (3000 *
              {{ agent1?.depositRatios }}% + 8000 * {{ agent1?.betRatios }}%) + (1000 *
              {{ agent1?.depositRatios }}% + 2000 * {{ agent1?.betRatios }}%) =
              {{
                formatter().format(
                  caculateNum(3000, 8000, agent1?.depositRatios, agent1?.betRatios) +
                    caculateNum(1000, 2000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}
            </li>
            <li class="li-circle ml-6">
              {{ $t('Activities.Agentrule.CommissionCalculation.B1TeamCommission') }} (6000 *
              {{ agent2?.depositRatios }}% + 3000 * {{ agent2?.betRatios }}%) =
              {{
                formatter().format(
                  caculateNum(6000, 3000, agent2?.depositRatios, agent2?.betRatios)
                )
              }}
            </li>
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.B2Commission') }}</li>
            <li class="ml-4">
              (0 * {{ agent1?.depositRatios }}% + 0 * {{ agent1?.betRatios }}%) =
              {{ formatter().format(0) }}
            </li>
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.B3Commission') }}</li>
            <li class="li-circle ml-6">
              (8000 * {{ agent1?.depositRatios }}% + 5000 * {{ agent1?.betRatios }}%) =
              {{
                formatter().format(
                  caculateNum(8000, 5000, agent1?.depositRatios, agent1?.betRatios)
                )
              }}
            </li>
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.ACommission') }}</li>
            <li class="li-circle ml-6">{{ $t('Activities.Agentrule.CommissionCalculation.ALevel1Team') }}</li>
            <li class="ml-6">
              (500 * {{ agent1?.depositRatios }}% + 1000 * {{ agent1?.betRatios }}%) +
              (2000 * {{ agent1?.depositRatios }}% + 1500 * {{ agent1?.betRatios }}%) +
              (1500 * {{ agent1?.depositRatios }}% + 2000 * {{ agent1?.betRatios }}%) =
              {{ formatter().format(num1) }}
            </li>
            <li class="li-circle ml-6">{{ $t('Activities.Agentrule.CommissionCalculation.ALevel2Team') }}</li>
            <li class="ml-6">
              (3000 * {{ agent2?.depositRatios }}% + 8000 * {{ agent2?.betRatios }}%) +
              (1000 * {{ agent2?.depositRatios }}% + 2000 * {{ agent2?.betRatios }}%) +
              (8000 * {{ agent2?.depositRatios }}% + 5000 * {{ agent2?.betRatios }}%) =
              {{ formatter().format(num2) }}
            </li>
            <li class="li-circle ml-6">{{ $t('Activities.Agentrule.CommissionCalculation.ALevel3Team') }}</li>
            <li class="ml-6">
              (6000 * {{ agent3?.depositRatios }}% + 3000 * {{ agent3?.betRatios }}%) =
              {{ formatter().format(num3) }}
            </li>
            <li>{{ $t('Activities.Agentrule.CommissionCalculation.TotalCommission') }}</li>
            <li class="ml-6">
              {{ formatter().format(num1) }} + {{ formatter().format(num2) }} +
              {{ formatter().format(num3) }} =
              {{ formatter().format(num1 + num2 + num3) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
import withTopNav from "@/layouts/withTopNav.vue";
import wuxianji_01 from "./images/wuxianji_01.png";
import wuxianji_02 from "./images/wuxianji_02.png";
import wuxianji_05 from "./images/wuxianji_05.png";
import wuxianji_09 from "./images/wuxianji_09.png";
import wuxianji_12 from "./images/wuxianji_12.png";
import wuxianji_14 from "./images/wuxianji_14.png";
import wuxianji_31 from "./images/wuxianji_31.png";
import wuxianji_18 from "./images/wuxianji_18.png";
import wuxianji_34 from "./images/wuxianji_34.png";
import wuxianji_28 from "./images/wuxianji_28.png";
import wuxianji_40 from "./images/wuxianji_40.png";
import wuxianji_43 from "./images/wuxianji_43.png";
import wuxianji_45 from "./images/wuxianji_45.png";
import wuxianji_47 from "./images/wuxianji_47.png";
import wuxianji_51 from "./images/wuxianji_51.png";
import { formatter } from "@/utils";
import DataTable from "@a/components/DataTable/index.vue";
import { getActivityDetail } from "@/api/activity";
import { useRoute } from "vue-router";
const activityId: any = useRoute().query.activityId || "";

const configInfo = ref<any>({});
const detailList = computed(() => configInfo.value?.configJson?.detailList || []);
const agent1 = computed(() => detailList.value.find((i) => i.level === "Level1"));
const agent2 = computed(() => detailList.value.find((i) => i.level === "Level2"));
const agent3 = computed(() => detailList.value.find((i) => i.level === "Level3"));

const getActivityDetailData = async () => {
  const res = await getActivityDetail({ activityId });
  if (res.code === 1) {
    configInfo.value = res.data;
    configInfo.value.configJson = JSON.parse(res.data.configJson);
    console.log("11111111111111");
    console.log(configInfo.value);
  }
};
const columns = [
  {
    title: "Usuário",
    key: "level",
  },
  {
    title: "Depósito válido",
    key: "name",
  },
  {
    title: "Aposta válida",
    key: "depositRatios",
  },
];

const data = [
  {
    level: "B1",
    name: 500,
    depositRatios: 1000,
  },
  {
    level: "B2",
    name: 2000,
    depositRatios: 1500,
  },
  {
    level: "B3",
    name: 1500,
    depositRatios: 2000,
  },
  {
    level: "C1",
    name: 3000,
    depositRatios: 8000,
  },
  {
    level: "C2",
    name: 1000,
    depositRatios: 2000,
  },
  {
    level: "C3",
    name: 8000,
    depositRatios: 5000,
  },
  {
    level: "D1",
    name: 6000,
    depositRatios: 3000,
  },
];
const caculateNum = (num1, num2, depositRatios, betRatios) => {
  return (num1 * depositRatios + num2 * betRatios) / 100;
};

const num1 = computed(
  () =>
    caculateNum(500, 1000, agent1.value?.depositRatios, agent1.value?.betRatios) +
    caculateNum(2000, 1500, agent1.value?.depositRatios, agent1.value?.betRatios) +
    caculateNum(1500, 2000, agent1.value?.depositRatios, agent1.value?.betRatios)
);

const num2 = computed(
  () =>
    caculateNum(3000, 8000, agent2.value?.depositRatios, agent2.value?.betRatios) +
    caculateNum(1000, 2000, agent2.value?.depositRatios, agent2.value?.betRatios) +
    caculateNum(8000, 5000, agent2.value?.depositRatios, agent2.value?.betRatios)
);

const num3 = computed(() =>
  caculateNum(6000, 3000, agent3.value?.depositRatios, agent3.value?.betRatios)
);

onMounted(async () => {
  getActivityDetailData();
});
</script>
